import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './ArticlesListPage.css'; // Importazione del file CSS specifico
import { Helmet } from 'react-helmet-async';
import {Link, useLocation} from "react-router-dom";
import ArticleCard from "../parts/ArticleCard";
import FilterBar from "../parts/FilterBar";

function ArticlesListPage(language) {
  // Hook per accedere alle traduzioni
  const { t, i18n } = useTranslation(); // Inizializza useTranslation
  const currentLang = language.language
  console.log("Current language in HomePage:", currentLang);
  const location = useLocation();

  const [articles, setArticles] = useState([]);
  const [filteredArticles, setFilteredArticles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [characters, setCharacters] = useState([]);
  const [locations, setLocations] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCharacters, setSelectedCharacters] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);

  // Read navigation state to apply initial filters
  useEffect(() => {
    if (location.state) {
      if (location.state.selectedCategories) {
        setSelectedCategories(location.state.selectedCategories);
      }
      if (location.state.selectedLocations) {
        setSelectedLocations(location.state.selectedLocations);
      }
      if (location.state.selectedCharacters) {
        setSelectedCharacters(location.state.selectedCharacters);
      }
    }
  }, [location.state]);

  // Helper per generare link localizzati
  const localizedPath = (path) => {
    // path deve iniziare con /
    if (!path.startsWith('/')) path = '/' + path;
    // Sostituisci la lingua nella url
    const parts = location.pathname.split('/');
    if (['it', 'en', 'es', 'fr', 'de', 'pt'].includes(parts[1])) {
      parts[1] = currentLang;
      return parts.slice(0, 2).join('/') + path;
    } else {
      return '/' + currentLang + path;
    }
  };

  useEffect(() => {
    const fetchArticles = async () => {
      try {
        let jsonPath = `/data/json/article/${currentLang}/list.json`;
        console.log("Fetching articles from:", jsonPath);
        const response = await fetch(jsonPath);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        setArticles(data);
        setFilteredArticles(data);

        // Extract unique categories from all articles
        const allCategories = new Set();
        // Extract unique characters from all articles
        const uniqueCharacters = new Map();
        // Extract unique locations from all articles
        const allLocations = new Set();

        data.forEach(article => {
          const articleCategories = article.categories.split(",")
          articleCategories.forEach(category => allCategories.add(category.trim()));
          article.characters.forEach(character => {
            uniqueCharacters.set(character.id, character);
          });
          // Extract locations
          if (article.location && Array.isArray(article.location)) {
            article.location.forEach(loc => allLocations.add(loc.trim()));
          }
        });
        setCategories(Array.from(allCategories).sort());
        setCharacters(Array.from(uniqueCharacters.values()));
        setLocations(Array.from(allLocations).sort());

      } catch (error) {
        console.error("Could not fetch articles:", error);
      }
    };
    fetchArticles().then(r => {});
  }, []);

  // Apply filters when selected categories, characters or locations change
  useEffect(() => {
    if (selectedCategories.length === 0 && selectedCharacters.length === 0 && selectedLocations.length === 0) {
      // No filters selected, show all articles
      setFilteredArticles(articles);
    } else {
      // Apply filters
      const filtered = articles.filter(article => {
        // Check if article matches selected categories with normalized comparison
        const categoryMatch = selectedCategories.length === 0 ||
            article.categories.split(",").some(articleCategory => {
              // Normalize article category (trim and lowercase)
              const normalizedArticleCategory = articleCategory.trim().toLowerCase();

              // Check if any selected category matches when normalized
              return selectedCategories.some(selectedCategory =>
                  selectedCategory.trim().toLowerCase() === normalizedArticleCategory
              );
            });

        // Check if article matches selected characters
        const characterMatch = selectedCharacters.length === 0 ||
            article.characters.some(character => selectedCharacters.includes(character.id));

        // Check if article matches selected locations
        const locationMatch = selectedLocations.length === 0 ||
            (article.location && Array.isArray(article.location) &&
             article.location.some(loc => selectedLocations.includes(loc.trim())));

        // Article must match all filters if applied
        return categoryMatch && characterMatch && locationMatch;
      });

      setFilteredArticles(filtered);
    }
  }, [selectedCategories, selectedCharacters, selectedLocations, articles]);

  // Handle category filter change
  const handleCategoryChange = (category) => {
    setSelectedCategories(prev => {
      if (prev.includes(category)) {
        return prev.filter(c => c !== category);
      } else {
        return [...prev, category];
      }
    });
  };

  // Handle character filter change
  const handleCharacterChange = (characterId) => {
    setSelectedCharacters(prev => {
      if (prev.includes(characterId)) {
        return prev.filter(id => id !== characterId);
      } else {
        return [...prev, characterId];
      }
    });
  };

  // Handle location filter change
  const handleLocationChange = (location) => {
    setSelectedLocations(prev => {
      if (prev.includes(location)) {
        return prev.filter(l => l !== location);
      } else {
        return [...prev, location];
      }
    });
  };

  // Clear all filters
  const handleClearFilters = () => {
    setSelectedCategories([]);
    setSelectedCharacters([]);
    setSelectedLocations([]);
  };

  // Handle category click from article card
  const handleCategoryClick = (e, category) => {
    e.preventDefault(); // Prevent the default link behavior

    // If already selected, do nothing (avoids toggling off)
    if (selectedCategories.includes(category)) {
      return;
    }

    // Add this category to selected categories
    setSelectedCategories(prev => [...prev, category]);

    // Scroll back to top to see filtered results
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Handle character click from article card
  const handleCharacterClick = (e, characterId) => {
    e.preventDefault(); // Prevent the default link behavior

    // If already selected, do nothing (avoids toggling off)
    if (selectedCharacters.includes(characterId)) {
      return;
    }

    // Add this character to selected characters
    setSelectedCharacters(prev => [...prev, characterId]);

    // Scroll back to top to see filtered results
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };




  return (
      <>
        {/*<Helmet>*/}
        {/*  <script src="/externaljs/tailwindcss_3.4.17.js"></script>*/}
        {/*</Helmet>*/}
        <main>

        <section className="text-center lg:py-0" >
          <FilterBar
              categories={categories}
              characters={characters}
              locations={locations}
              selectedCategories={selectedCategories}
              selectedCharacters={selectedCharacters}
              selectedLocations={selectedLocations}
              onCategoryChange={handleCategoryChange}
              onCharacterChange={handleCharacterChange}
              onLocationChange={handleLocationChange}
              onClearFilters={handleClearFilters}
          />
          <div className="filter-summary">
            {(selectedCategories.length > 0 || selectedCharacters.length > 0 || selectedLocations.length > 0) && (
                <p>
                  {t('homePage.filtersApplied')}
                  {selectedCategories.length > 0 && (
                      <span className="filter-tag">{t('homePage.categories')} {selectedCategories.join(', ')}</span>
                  )}
                  {selectedCharacters.length > 0 && (
                      <span className="filter-tag">{t('homePage.characters')} {
                        selectedCharacters.map(id =>
                            characters.find(c => c.id === id)?.name
                        ).filter(Boolean).join(', ')
                      }</span>
                  )}
                  {selectedLocations.length > 0 && (
                      <span className="filter-tag">{t('homePage.locations')} {selectedLocations.join(', ')}</span>
                  )}
                  <span className="results-count">
              ({filteredArticles.length} {filteredArticles.length === 1 ? t('homePage.result') : t('homePage.results')})
            </span>
                </p>
            )}
          </div>
        </section>
        <section className="py-16" id="articles">
          <h2 className="text-3xl font-bold text-center mb-12">{t('articlesPage.allArticles')}</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.length > 0 ? (
                filteredArticles.slice(-9).map(article => (<ArticleCard article={article} currentLang={currentLang} key={article.id+currentLang} />))
            ) : (
                <div className="no-results">
                  <p>{t('homePage.noResults')}</p>
                </div>
            )}
          </div>
        </section>

        {/* Sezione citazione di Seneca */}
        <section className="py-16 lg:py-24">
          <div className="max-w-4xl mx-auto text-center px-4">
            <div className="relative" style={{padding: "2em"}}>
              <svg className="absolute top-0 left-0 w-12 h-12 opacity-60 -mt-4 -ml-4 main-h-color" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
              <blockquote className="text-2xl md:text-3xl font-serif italic mb-6 main-h-color leading-relaxed">
                {t('articlesPage.senecaQuote')}
              </blockquote>
              <div className="text-right">
                <cite className="text-lg font-semibold text-gradient not-italic">— Seneca</cite>
                <p className="text-sm text-gray-400 mt-1">{t('articlesPage.senecaQuoteSource')}</p>
              </div>
              <svg className="absolute bottom-0 right-0 w-12 h-12 opacity-60 -mb-4 -mr-4 transform rotate-180 main-h-color" fill="currentColor" viewBox="0 0 32 32">
                <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" />
              </svg>
            </div>
          </div>
        </section>

        <section className="py-20 lg:py-32" id="about">

        </section>
        </main>

      </>
  );
}

export default ArticlesListPage;
